import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "SSR, SSRwR, SSG, CSR, WTFBBQ???",
  "description": "hese abbreviations are getting out of hand. It's like a bad interviewer's wet dream.",
  "categories": "nextjs, gatsby, technical",
  "published": "2020-11-24T00:00:00.000Z",
  "hero": "./img/screenshot-1606234394207.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`These abbreviations are getting out of hand Friend. It's like a bad interviewer's wet dream.`}</p>
    <p><em parentName="p">{`"Tell me, what is the difference between rehydrated SSR on a gibson supercomputer with 20kilobytes of RAM versus an SSG SPA on a horizontal supercluster with K8s and a11y?"`}</em></p>
    <p>{`I don't know, damn it, I use tech to solve problems and make money. Who cares what it's called, we're not 12 year old Star Trek nerds.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Lol I love those acronyms. I deeply dislike the whole SSR, SSG, SHFVahGssSSSS acronyms that we have nowadays, and different products meaning different things with them (worse because they're both right!)`}</p>{`— Obed Parlapiano (@ObedParla) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/ObedParla/status/1330790562677612546"
      }}>{`November 23, 2020`}</a></blockquote>
    <h2 {...{
      "id": "knowing-the-name-of-the-thing-vs-understanding-the-thing"
    }}>{`Knowing the name of the thing vs understanding the thing`}</h2>
    <blockquote>
      <p parentName="blockquote">{`You can know the name of a bird in all the languages of the world and you'll know absolutely nothing about the bird... So let's look at the bird and see what it's doing — that's what counts`}</p>
    </blockquote>
    <lite-youtube {...{
      "videoid": "lFIYKmos3-s",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Nerds like to forget that you don't know much, if all you know is the name. Especially if you step on a nerve. `}</p>
    <p>{`Debates rage online and in tech teams bikeshedding on the names of things. Super common with folks who just read a book about it. Once you notice, it's everywhere.`}</p>
    <p>{`Are you using The Strangler Pattern or are you slowly replacing old functionality with new? 🤔`}</p>
    <p>{`Names help you move faster as a team. But if you see an interviewer fussing about the names of things, run away.`}</p>
    <h2 {...{
      "id": "ssr-vs-ssg-vs-spa-vs-csr-🤨"
    }}>{`SSR vs SSG vs SPA vs CSR 🤨`}</h2>
    <p>{`Last week I wrote about `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/gatsby-to-nextjs-pt1-server-side-render-or-server-side-generate"
      }}>{`server side rendering and server side generation`}</a>{` and got it backwards. What I called SSG is SSR and what I called SSR is ... checks notes ... CSRwPR`}</p>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media1.giphy.com/media/3ornjSL2sBcPflIDiU/giphy-loop.mp4?cid=7cf28b0f14usvj4cy5b2uupfaac613oa4bfe7ifffoqll0cp&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <p>{`The whole thing is a spectrum. From full server rendering to full client side rendering.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "und",
        "dir": "ltr"
      }}>{` `}<a parentName="p" {...{
          "href": "https://t.co/rkkDm28l44"
        }}>{`pic.twitter.com/rkkDm28l44`}</a></p>{`— Jared Palmer (@jaredpalmer) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/jaredpalmer/status/1330673290977873920"
      }}>{`November 23, 2020`}</a></blockquote>
    <p>{`And as taxonomies always are, that table is subtly wrong. `}</p>
    <p>{`Gatsby pre-renders whole pages not just their shell and they work without JavaScript, but don't remove it. NextJS can do full CSR, but also SSR with rehydration or pre-rendered CSR.`}</p>
    <p>{`Never trust a taxonomy my friend.`}</p>
    <h2 {...{
      "id": "which-should-you-use"
    }}>{`Which should you use?`}</h2>
    <p>{`On ep18 of CodeWithSwiz 👇 we dug into all this and found `}<em parentName="p">{`the`}</em>{` important factor.`}</p>
    <lite-youtube {...{
      "videoid": "tblxgTpDOcQ",
      "videostartat": "0"
    }}></lite-youtube>
    <p><strong parentName="p">{`If your page needs data, you're gonna have to get that data.`}</strong>{` The only difference is when.`}</p>
    <p>{`Pages rendered in the browser suffer from the loading spinner effect. Open page, wait for data to load. `}</p>
    <p>{`Clients do the waiting, and your bandwidth and server use is low – mostly data and lots of small requests. `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/the-ultimate-test-for-your-webapp:-airplane-wifi"
      }}>{`Sucks on airplane wifi`}</a>{` with high latency.`}</p>
    <p>{`Pages rendered on the server suffer from the full page reload problem. You click a link and get a whole new page. `}</p>
    <p>{`No requests on the client, but you're transferring all the HTML every time. Even the header and footer that always stay the same. Takes up lots of server resources and sucks on networks with low bandwidth. `}</p>
    <h3 {...{
      "id": "steps-between-extremes"
    }}>{`Steps between extremes`}</h3>
    <p>{`You can't solve this problem. You can smudge the cost around.`}</p>
    <p>{`With static site generators like Gatsby, you make those API requests at deploy time. Creates slow deploys and fantastically speedy pages.`}</p>
    <p>{`No data fetching on the server `}<em parentName="p">{`or`}</em>{` the client. Pure speed.`}</p>
    <p>{`But if each page takes 2 seconds to generate and you're deploying 1000 ... that's 33 minutes. 😅`}</p>
    <p>{`With hybrids like NextJS, you have a choice.`}</p>
    <p>{`Use SSR – server side rendering – and you're doing those 2 seconds worth of requests `}<em parentName="p">{`on every page load for every user`}</em>{`. Maybe that's okay, maybe it isn't.`}</p>
    <p>{`Use SSG – server side generation – and you're doing those 2 seconds worth of requests on `}<em parentName="p">{`some page loads for some of the users`}</em>{`. It's a cache.`}</p>
    <p>{`First user hits your page: 2 second load. Second user hits the cache: blazing speed. Wait a few hours, next user gets 2 second load, page left the cache.`}</p>
    <p>{`Maybe that's okay, maybe it isn't.`}</p>
    <p>{`Frameworks like Ruby on Rails Turbolinks and (I think) RemixRun take a different approach still. Each request gets full HTML, but for a specific `}<inlineCode parentName="p">{`<div>`}</inlineCode>{` on the page.`}</p>
    <p>{`Like loading your page in fragments.`}</p>
    <h2 {...{
      "id": "how-do-you-pick-then"
    }}>{`How do you pick then?`}</h2>
    <p><em parentName="p">{`You`}</em>{` know the performance characteristics for your project. There is no solution.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Interesting discovery today:`}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/NextJS?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#NextJS`}</a>{` SSG page: 2 second load`}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/Gatsby?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#Gatsby`}</a>{` SSR page: 28ms load`}<br parentName="p"></br><br parentName="p"></br>{`Same page.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1330645071729811456"
      }}>{`November 22, 2020`}</a></blockquote>
    <p>{`Same page takes 28ms to load with Gatsby, 2s with NextJS's SSR. Yes I used the wrong words in my tweet.`}</p>
    <p>{`Is that okay? 🤷‍♂️`}</p>
    <p>{`Do you care about fast initial loads, useful initial loads, average performance, fastest performance, slowest performance? Depends what you're building.`}</p>
    <p>{`And remember, there is no cake, only tradeoffs.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`PS: we're launching `}<a parentName="p" {...{
        "href": "https://learnetto.com/blackfriday"
      }}>{`a big bundle tomorrow`}</a>{` and courses inside talk about this in more detail`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      